import { InputFileValue } from './types';

export const DEFAULT_INPUT_FILE_VALUE: InputFileValue = {
    localFiles: [],
    uploadedFiles: [],
};
